var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cellList',{attrs:{"cell-list":_vm.keywordList,"thumbnail-info":_vm.thumbnailInfo,"container-class-name":"cell-list responsive cell-poster"},on:{"cell-click-log":_vm.sendCellClickLog}})}
var staticRenderFns = []

export { render, staticRenderFns }